import { Expression } from './Expression.js';
export class StaticOperationDefExpression extends Expression {
    constructor(name, paramNames, inContextDef) {
        super();
        this.name = name;
        this.paramNames = paramNames;
        this.inContextDef = inContextDef;
    }
    evaluate(visitor, localVariables) {
        const typeName = visitor.getTargetTypeName();
        visitor.enrichStatic(typeName, this.name, (...params) => {
            let operationParams = {};
            if (this.paramNames) {
                this.paramNames.forEach((v, i) => operationParams[v] = params[i]);
            }
            const locals = Object.assign(Object.assign({}, localVariables), operationParams);
            return this.inContextDef.evaluate(visitor, locals);
        });
    }
}
//# sourceMappingURL=StaticOperationDefExpression.js.map